import {
  Typography,
  Grid,
} from '@mui/material';
import CardProject from '..';
import { Project, StatusProjectProps } from '../../../../../config/interfaces';

export default function StatusProjectsContent(props: StatusProjectProps) {
  const { projects, name, refetch } = props;
  return (
    <Grid
      container
      sx={{
        my: 4,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        component="h2"
        variant="h4"
        sx={{
          mb: 2,
          color: '#58595b',
          fontWeight: 500,
        }}
      >
        {name}
      </Typography>
      {projects && projects.length > 0 ? (
        <Grid
          sx={{
            width: '100%',
            overflowX: 'auto',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
          }}
        >
          {projects.map((project: Project) => (
            <CardProject
              key={project.id}
              project={project}
              refetch={refetch}
            />
          ))}
        </Grid>
      ) : (
        <Typography
          component="p"
          variant="body2"
        >
          You don&apos;t have projects
        </Typography>
      )}
    </Grid>
  );
}
